import { setupApp } from "./app";

(async function () {
    const { app } = await setupApp(window.location.pathname);
    app.mount("#app");
})();
